import type { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { Text } from '@/shared/ui'
import { IInstitution } from '@/interfaces/institutions'
import style from './institution-item.module.scss'

interface InstitutionItemProps extends Omit<HTMLProps<HTMLDivElement>, 'name' | 'id'>, IInstitution {
  showCountry?: boolean
}

export const InstitutionItem = (props: InstitutionItemProps) => {
  const { className, name, country, logo, showCountry = false, url } = props
  const imageUrl = logo?.url ?? country?.image?.url

  return (
    <a
      href={url ? url : undefined}
      target="_blank"
      className={clsx(style.container, { [style.containerLink]: Boolean(url) }, className)}
    >
      {imageUrl && (
        <div className={style.logo}>
          <Image src={imageUrl} alt={name} fill />
        </div>
      )}
      {name && (
        <Text className={style.text} color="dark" type="t2" tagName="p">
          {name}
        </Text>
      )}
      {/* TODO: Добавить отображение country по флагу showCountry  */}
    </a>
  )
}
